<template>
  <div class="wrap">
    <div class="list rowJb">
      <div class="emptyBox colAc" v-if="list.length == 0">
        <img src="../../assets/static/emptyList.png" alt="" />
        <div>暂时还没有校区哦</div>
      </div>
      <div class="listitem" v-for="(item, index) in list" :key="index">
        <div class="itemLine rowAc">
          <div class="icon-campus icon"></div>
          <div class="title textOverz">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInstitutionCampusAPI } from "../../utils/api/api";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    console.log(this.$route.query.institutionCode);
    this.getInstitutionCampus();
  },
  methods: {
    //获取管辖机构列表
    getInstitutionCampus() {
      var obj = {
        code: this.$route.query.institutionCode,
      };
      console.log("校区列表obj", obj);
      getInstitutionCampusAPI(obj).then((res) => {
        if (res.resultCode == 200) {
          console.log("获取列表成功", res.data);
          this.list = res.data;
        } else {
          console.log(res.resultStr);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;
  background: #f4faff;
  padding: 5px 0px 5px 0.15rem;
  box-sizing: border-box;
  overflow: auto;
}
.list {
  padding-right: 0.15rem;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
  flex-wrap: wrap;
}
.listitem {
  margin-top: 15px;
  width: 164px;
  height: 64px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 4px 4px 11px 0px rgba(229, 236, 243, 0.8),
    -9px -9px 22px 0px rgba(229, 236, 243, 0.1);
  border-radius: 10px;
  padding: 12px 0px 32px 12px;
}
.icon {
  font-size: 14px;
  color: #6985ff;
  margin-right: 3px;
}
.itemLine {
  color: #333843;
  font-size: 14px;
  line-height: 20px;
}
</style>